import { Teacher } from '../generated/Teacher';
import { Communicate } from '../generated/Communicate';
import { UserAuth } from '../generated/UserAuth';
import { TeacherFileDTO } from './TeacherFileDTO';
import { DaTeacher } from '../generated/DaTeacher';
import { DaCourseOperator } from '../generated/DaCourseOperator';
export class TeacherInfoInputDTO {
  userAuth: UserAuth = new UserAuth();
  teacher: Teacher = new Teacher();
  communicate: Communicate = new Communicate();
  files: TeacherFileDTO = new TeacherFileDTO();
  da_teacher: DaTeacher = new DaTeacher();
  da_course_operator: DaCourseOperator[] = [];
  total_lesson_count = 0;
  total_student_count = 0;
}
